import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { blue } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    primary: {
      // light: blue["A200"],
      // main: blue["A400"],
      // dark: blue["A700"],
      light: blue["200"],
      main: blue["400"],
      dark: blue["700"],
    },
  },
});

const ThemeProviderShowAttachBtn = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeProviderShowAttachBtn;
